import { Box, ChakraProvider, Drawer, DrawerContent, DrawerOverlay, Flex, IconButton, useDisclosure } from '@chakra-ui/react';
import React from 'react';
import { Outlet } from 'react-router-dom';
import { adminTheme } from '../design';
import AdminSidebar from './AdminSidebar';
import { FiMenu } from 'react-icons/fi';

export default function AdminLayout() {
    return (
        <ChakraProvider theme={adminTheme}>
            <Layout />
        </ChakraProvider>
    )
}

const Layout = () => {
    const { isOpen, onOpen, onClose } = useDisclosure();

    return (
        <Box minH={'100vh'} backgroundColor={'#EDF2F7'}>
            <AdminSidebar onClose={onClose} display={{ base: 'none', md: 'block' }} />

            <Drawer autoFocus={false} isOpen={isOpen} placement="left" onClose={onClose} returnFocusOnClose={false} onOverlayClick={onClose}>
                <DrawerOverlay />
                <DrawerContent>
                    <AdminSidebar onClose={onClose} />
                </DrawerContent>
            </Drawer>

            <Flex
                ml={{ base: 0, md: '250px' }}
                flexDir="column"
                minH="100vh"
                bgGradient="linear(to-br, orange.50, white)"
            >

                <IconButton
                    display={{ base: 'flex', md: 'none' }}
                    onClick={onOpen}
                    icon={<FiMenu />}
                    variant="outline"
                    aria-label="open menu"
                />

                <Box w="full" px={{ base: 2, md: 5 }} py={4}>
                    <Outlet />
                </Box>
            </Flex>
        </Box>
    )
}
